import React, { Component } from 'react';
import Checkbox from 'components/Checkbox/Checkbox'
import { HttpService } from 'services/HttpService';
import { TokenService } from 'services/TokenService';
import CircleLoader from 'components/CircleLoader/CircleLoader';
import CookieService from 'services/CookieService';
import MessageBox from 'components/MessageBox/MessageBox';
import { Link } from 'react-router-dom';
import AnalyticsService from 'services/AnalyticsService';
import './LoginForm.scss';
import { H } from 'highlight.run';

export class LoginFormComponent extends Component {

  rememberMeCheckbox = {
    id: "remember_me",
    text: "",
    color: "secondary",
    classes: "margin-t-0 margin-b-0"
  }

  messageBox = {
    title: "Login Failed",
    message: "Check your Email and enter the verification code to reset your Password.",
    color: "danger",
    icon: "error",
  }

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.saveLoginCookies = this.saveLoginCookies.bind(this);
    this.onSuccessRequest = this.onSuccessRequest.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.onMessageClose = this.onMessageClose.bind(this);
    this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    this.state = {
      email: '',
      password: '',
      loaderIsActive: false,
      rememberMe: false,
      showPassword: false,
      token: '',
      showMessageBox: false
    };
  }

  componentDidMount() {
    this.getCookies();
  }

  getCookies() {
    const email = new CookieService().getCookie('email');
    this.setState({
      email: email,
    });
  }

  onMessageClose(event) {
    this.setState({ showMessageBox: false });
  }

  handleChangeCheckbox(isChecked) {
    this.setState({ rememberMe: isChecked });
  }

  onEmailChange(email) {
    this.setState({email: email})
  }

  onPasswordChange(password) {
    this.setState({password: password})
  }

  togglePasswordVisibility() {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  }

  handleSubmit(event) {
    localStorage.removeItem('userData');
    this.setState({ loaderIsActive: true, showMessageBox: false })
    const host = process.env.REACT_APP_SERVER;
    const body = {
      "email": this.state.email,
      "password": this.state.password
    };
    new HttpService().sendRequest(`${host}/api/users/login`,{
      body: JSON.stringify(body),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then((result) => {

      if(result.hasOwnProperty('token')) {
        const { email, firstName, lastName, phoneNumber, companyName, _id } = result;
        H.identify(email, {
          id: _id ?? email,
          firstName,
          email,
          lastName,
          phoneNumber,
          companyName
        });
        this.onSuccessRequest(result);
      } else {
        this.setState({ showMessageBox: true });
        const { message = 'Email or Password incorrect.' } = result;
        this.messageBox.message = message.message || message;
      }

      this.setState({ loaderIsActive: false });
    })
    .catch((err, code) => {
      this.messageBox.message = `Login Failed: ${err}`;
      this.setState({ showMessageBox: true });
      this.setState({ loaderIsActive: false });
    })
    event.preventDefault();
  }

  onSuccessRequest(result) {
    const { token, userType, email } = result;
    this.setState({ token });
    const tokenService = new TokenService();
    const cookieService = new CookieService();
    cookieService.setCookie({ name: 'user_type', value: userType }, 10);
    AnalyticsService.setUserId(email);
    tokenService.saveToken(token);
    this.saveLoginCookies(result).then(() => {
      this.props.onSubmit(result);
    });
  }

  saveLoginCookies(result) {
    const { email, token } = result;
    return new Promise((resolve, reject) => {
      let cookies = [
        {
          name: "token",
          value: token
        },
      ];

      if (this.state.rememberMe) {
        cookies = [...cookies, {
          name: "email",
          value: email
        }];
      }

      new CookieService().setCookies(cookies, 30);
      setTimeout(resolve(), 100);
    });
  }

  render() {
    const { showMessageBox = false, email, password, showPassword, loaderIsActive } = this.state;
    return (
      <form className="o-login-form" onSubmit={this.handleSubmit}>
        <h1 className="o-login-form__title">Welcome back</h1>
        <p className="o-login-form__subtitle">Log in to pick up where you left off.</p>

        <div className="o-login-form__field">
          <label className="o-login-form__label" htmlFor="login-email">Email Address</label>
          <div className="o-login-form__input-box">
            <i className="material-icons">mail_outline</i>
            <input
              id="login-email"
              className="o-login-form__input"
              type="email"
              autoComplete="email"
              placeholder="name@company.com"
              value={email || ''}
              onChange={(event) => this.onEmailChange(event.target.value)}
              required
            />
          </div>
        </div>

        <div className="o-login-form__field">
          <label className="o-login-form__label" htmlFor="login-password">Password</label>
          <div className="o-login-form__input-box">
            <i className="material-icons">lock_outline</i>
            <input
              id="login-password"
              className="o-login-form__input"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              placeholder="Enter your password"
              value={password || ''}
              onChange={(event) => this.onPasswordChange(event.target.value)}
              required
            />
            <button
              type="button"
              className="o-login-form__reveal"
              onClick={this.togglePasswordVisibility}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <i className="material-icons">{showPassword ? 'visibility_off' : 'visibility'}</i>
            </button>
          </div>
        </div>

        <div className="o-login-form__options">
          <div className="o-login-form__remember">
            <Checkbox {...this.rememberMeCheckbox} handleChange={this.handleChangeCheckbox} />
            {/* Checkbox's own label is empty, so this one carries the accessible
                name and makes the words clickable again. */}
            <label className="o-login-form__remember-text" htmlFor="remember_me__checkbox_id">Remember me</label>
          </div>
          <Link to={`/forgot-password/${email || ''}`} className="o-login-form__forgot">
            Forgot password?
          </Link>
        </div>

        {
          !loaderIsActive ?
          <button className="o-login-form__submit" type="submit" value="Submit">
            <span>Log in</span>
          </button>
          : <CircleLoader isActive={loaderIsActive} />
        }

        <div className="o-login-form__signup">
          <span>Don't have an account?</span>
          <Link to={`/sign-up`}>
            Sign up
            <i className="material-icons">arrow_forward</i>
          </Link>
        </div>

        {
          showMessageBox ?
          <MessageBox {...this.messageBox} onClose={this.onMessageClose} />
          : ''
        }
      </form>
    )
  }
}

export default LoginFormComponent
